module.exports = __webpack_public_path__ + "img/bg.211e6864.png";